import { BASE_CLASS_PREFIX } from '../base/constants';

const PREFIX = `${BASE_CLASS_PREFIX}-spin`;

const cssClasses = {
    PREFIX
};

const strings = {
    SIZE: ['small', 'middle', 'large']
};

const numbers = {};

export { cssClasses, strings, numbers };
